import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bulkUpdateRsvpRequest = { fields: 'google.protobuf.FieldMask' };
var _bulkUpdateRsvpResponse = { rsvps: '_rsvp' };
var _checkIn = { created: 'google.protobuf.Timestamp' };
var _checkInRsvpRequest = {};
var _checkInRsvpResponse = { rsvp: '_rsvp' };
var _createRsvpRequest = { form: '_formResponse' };
var _createRsvpResponse = { rsvp: '_rsvp' };
var _deleteRsvpCheckInRequest = {};
var _deleteRsvpCheckInResponse = { rsvp: '_rsvp' };
var _deleteRsvpRequest = {};
var _deleteRsvpResponse = {};
var _formattedAddress = { address: '_address' };
var _formResponse = { inputValues: '_inputValue' };
var _getRsvpRequest = {};
var _getRsvpResponse = { rsvp: '_rsvp' };
var _guest = { checkIn: '_checkIn' };
var _inputValue = {
    number: 'google.protobuf.DoubleValue',
    dateTime: 'google.protobuf.Timestamp',
    address: '_formattedAddress',
};
var _listRsvpRequest = {};
var _listRsvpResponse = { rsvps: '_rsvp' };
var _queryRsvpRequest = {};
var _queryRsvpResponse = { rsvps: '_rsvp' };
var _rsvp = {
    created: 'google.protobuf.Timestamp',
    modified: 'google.protobuf.Timestamp',
    rsvpForm: '_formResponse',
    guests: '_guest',
};
var _updateRsvpRequest = {
    fields: 'google.protobuf.FieldMask',
    rsvpForm: '_formResponse',
};
var _updateRsvpResponse = { rsvp: '_rsvp' };
function resolveWixEventsRsvpRsvpManagementUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/rsvp',
                destPath: '/v1/rsvp',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/events/v1/rsvp',
                destPath: '/v1/rsvp',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of up to 100 RSVPs, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-rsvps). */
export function listRsvp(payload) {
    var _a = serializer(_listRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __listRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'GET',
            methodFqn: 'wix.events.rsvp.RsvpManagement.ListRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRsvp.fromReq = fromReq;
    __listRsvp.__isAmbassador = true;
    return __listRsvp;
}
/** Retrieves a list of up to 100 RSVPs, supporting [structurized queries](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-rsvps). */
export function queryRsvp(payload) {
    var _a = serializer(_queryRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __queryRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvp.RsvpManagement.QueryRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRsvp.fromReq = fromReq;
    __queryRsvp.__isAmbassador = true;
    return __queryRsvp;
}
/** Retrieves an RSVP. */
export function getRsvp(payload) {
    var _a = serializer(_getRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __getRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'GET',
            methodFqn: 'wix.events.rsvp.RsvpManagement.GetRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp/{rsvpId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixEventsRsvpRsvpManagementUrl({
                        protoPath: '/v1/rsvp/{rsvpId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getRsvp.fromReq = fromReq;
    __getRsvp.__isAmbassador = true;
    return __getRsvp;
}
/** Creates an RSVP, associated with a contact of the site. */
export function createRsvp(payload) {
    var _a = serializer(_createRsvpRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __createRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvp.RsvpManagement.CreateRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRsvp.fromReq = fromReq;
    __createRsvp.__isAmbassador = true;
    return __createRsvp;
}
/** Updates an RSVP. See [partial updates](https://dev.wix.com/api/wix-events/partial-updates). */
export function updateRsvp(payload) {
    var _a = serializer(_updateRsvpRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __updateRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'PATCH',
            methodFqn: 'wix.events.rsvp.RsvpManagement.UpdateRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp/{rsvpId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateRsvp.fromReq = fromReq;
    __updateRsvp.__isAmbassador = true;
    return __updateRsvp;
}
/** Updates multiple RSVPs - status only. */
export function bulkUpdateRsvp(payload) {
    var _a = serializer(_bulkUpdateRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __bulkUpdateRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'PATCH',
            methodFqn: 'wix.events.rsvp.RsvpManagement.BulkUpdateRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateRsvp.fromReq = fromReq;
    __bulkUpdateRsvp.__isAmbassador = true;
    return __bulkUpdateRsvp;
}
/** Deletes an RSVP. */
export function deleteRsvp(payload) {
    var _a = serializer(_deleteRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRsvpResponse, {}).fromJSON;
    function __deleteRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'DELETE',
            methodFqn: 'wix.events.rsvp.RsvpManagement.DeleteRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteRsvp.fromReq = fromReq;
    __deleteRsvp.__isAmbassador = true;
    return __deleteRsvp;
}
/** Checks-in an RSVP. */
export function checkInRsvp(payload) {
    var _a = serializer(_checkInRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkInRsvpResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __checkInRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvp.RsvpManagement.CheckInRsvp',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp/check-in',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkInRsvp.fromReq = fromReq;
    __checkInRsvp.__isAmbassador = true;
    return __checkInRsvp;
}
/** Deletes an RSVP check-in. */
export function deleteRsvpCheckIn(payload) {
    var _a = serializer(_deleteRsvpCheckInRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRsvpCheckInResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __deleteRsvpCheckIn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.rsvp',
            method: 'DELETE',
            methodFqn: 'wix.events.rsvp.RsvpManagement.DeleteRsvpCheckIn',
            url: resolveWixEventsRsvpRsvpManagementUrl({
                protoPath: '/v1/rsvp/check-in',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteRsvpCheckIn.fromReq = fromReq;
    __deleteRsvpCheckIn.__isAmbassador = true;
    return __deleteRsvpCheckIn;
}
//# sourceMappingURL=http.impl.js.map